export const debug =
  (...args: unknown[]) =>
    import.meta.env.DEV && console.log(...args)